import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Container, Row, Col } from 'reactstrap';
import Map from '../components/maps/map';
import classnames from 'classnames';
import ReactGA from 'react-ga';

class Maps extends Component {

    constructor(props) {
        super(props);
        this.state = {
            latitude: '',
            longitude: '',
            activeTab: 'services',
        }
    }

    toggle = (activeTab) => {
        if (this.state.activeTab !== activeTab) {
            this.setState({ activeTab });
        }
    }

    async componentDidMount() {
        let position = await this.geCurrenttLocation();
        // console.log("position",position);
        this.setState({ latitude: position.coords.latitude, longitude: position.coords.longitude })
        // console.log(window.location);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    geCurrenttLocation = () => {
        const geolocation = navigator.geolocation;

        return new Promise((resolve, reject) => {
            if (!geolocation) {
                reject(new Error("Not Supported"));
            }
            geolocation.getCurrentPosition((position) => {
                resolve(position);
            }, (e) => {
                reject(e.message)
            });
        })

    }

    render() {
        return (
            <Container fluid className='my-4'>
                <Row>
                    <Col>
                        <Nav tabs>
                            <NavItem>
                                <NavLink 
                                    className={classnames({ active: this.state.activeTab === 'services' })} 
                                    onClick={() => { this.toggle('services'); }}
                                >
                                    Services
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === 'survey' })}
                                    onClick={() => { this.toggle('survey'); }}
                                >
                                    Survey
                                </NavLink>
                            </NavItem>
                        </Nav>     
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="services">
                                {this.state.activeTab === 'services' && <Map types="SERVICES" latitude={this.state.latitude} longitude={this.state.longitude} />}
                            </TabPane>
                            <TabPane tabId="survey">
                                {this.state.activeTab === 'survey' && <Map types="SURVEY" latitude={this.state.latitude} longitude={this.state.longitude} />}
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default Maps;